import React from 'react';
import PropTypes from 'prop-types';
import { sortBy, uniqWith, isEqual } from 'lodash';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Icon,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { injectIntl } from 'react-intl';
import { APPROVAL_LEVELS } from '../../../../../utils/util-constants';

const RenewalsApprovalRequiredPanel = (props) => {
  const validations = uniqWith(sortBy(props.validations, ['category', 'itemCode']), isEqual);
  const tier1Validations = validations.filter(
    (validation) => validation.validityLevel === APPROVAL_LEVELS.TIER1_APPROVAL
  );
  const tier2Validations = validations.filter(
    (validation) => validation.validityLevel === APPROVAL_LEVELS.TIER2_APPROVAL
  );
  const tier3Validations = validations.filter(
    (validation) => validation.validityLevel === APPROVAL_LEVELS.TIER3_APPROVAL
  );

  return (
    <>
      {validations.length > 0 ? (
        <Accordion className="expansion-panel" defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Icon color="error">error</Icon>
            <Typography className="customer-options">
              {props.intl.formatMessage({
                id: 'approval_required'
              })}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography component="div">
              <p>
                {props.intl.formatMessage({
                  id: 'approval_reason_message'
                })}
                :
              </p>
              <ul>
                {validations.map((validation, index) => (
                  <li key={index}>{validation.message}</li>
                ))}
              </ul>
{/*
              <ul>
                {!!tier1Validations && !!tier1Validations.length ? (
                  <li>
                    {props.intl.formatMessage({
                      id: 'tier1_approval'
                    })}
                    <ul>
                      {tier1Validations.map((validation, index) => (
                        <li key={index}>{validation.message}</li>
                      ))}
                    </ul>
                  </li>
                ) : null}
                {!!tier2Validations && !!tier2Validations.length ? (
                  <li>
                    {props.intl.formatMessage({
                      id: 'tier2_approval'
                    })}
                    <ul>
                      {tier2Validations.map((validation, index) => (
                        <li key={index}>{validation.message}</li>
                      ))}
                    </ul>
                  </li>
                ) : null}
                {!!tier3Validations && !!tier3Validations.length ? (
                  <li>
                    {props.intl.formatMessage({
                      id: 'tier3_approval'
                    })}
                    <ul>
                      {tier3Validations.map((validation, index) => (
                        <li key={index}>{validation.message}</li>
                      ))}
                    </ul>
                  </li>
                ) : null}
              </ul>
*/}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ) : null}
    </>
  );
};

RenewalsApprovalRequiredPanel.propTypes = {
  validations: PropTypes.arrayOf(PropTypes.object)
};

export default injectIntl(RenewalsApprovalRequiredPanel);
